export default __webpack_public_path__ + "static/char-s-sp01-ko-8bc60ca509d2f18e24addc2a74e42a92.png";